// Catalog annotation carrying the Panda `ba` (product) value for an entity.
// Set on a squad's catalog-info.yaml, it both surfaces the Panda usage tab and
// scopes the CloudWatch metrics (the `ba` dimension) shown on it. Prefix aligns
// with the CloudWatch namespace (OpenTelemetry/agentfact-*) and the Terraform
// app_name `agentfact`.
export const BA_ANNOTATION = 'agentfact.tdf/ba';

// The browse base SaaS default lives in the shared jira module (components/jira/presets),
// alongside the instance presets and the project-URL helper. Re-exported here so
// pandaUsage callers keep their import path. The annotation is gone: the browse
// base is now stored as BACKSTAGE_JIRA_BROWSE_BASE_URL in the modifiable-attributes
// secret and read from the usage report.
export { DEFAULT_JIRA_BROWSE_BASE } from '../../components/jira/presets';
